import { Fragment } from 'react';
import styled from 'styled-components';

export default function Avatar({ onClick, avatarShape, avatar, avatarBorder, avatarLink }) {
	if (!avatar || !avatar.length) {
		return false;
	}

	function doOnClick(e) {
		onClick(e, buttonId);
	}

	return (
		<StyledAvatar id="slp-avatar" className={`container text-center`}>
			<StyledImgWrapper
				as={avatarLink && avatarLink.length > 0 ? 'a' : 'span'}
				href={avatarLink && avatarLink.length > 0 ? avatarLink : ''}
				avatar={avatar}
				avatarShape={avatarShape}
				// onClick={doOnClick}
				rel="noopener noreferrer"
				style={{
					border: '1' === avatarBorder && '' === avatarShape ? '3px solid' : '',
				}}
			>
				<StyledImg src={avatar} />
				{'1' === avatarBorder && 'square' === avatarShape && (
					<svg
						viewBox="0 0 24 24"
						xmlns="http://www.w3.org/2000/svg"
						width="100%"
						height="100%"
						fill="currentColor"
					>
						<path d="M24 0H0v24h24V0Zm-.5.5v23H.5V.5h23Z" />
					</svg>
				)}
				{'1' === avatarBorder && 'circle' === avatarShape && (
					<svg
						viewBox="0 0 24 24"
						xmlns="http://www.w3.org/2000/svg"
						fillRule="evenodd"
						width="100%"
						height="100%"
						fill="currentColor"
					>
						<path d="M12 0c6.623 0 12 5.377 12 12s-5.377 12-12 12S0 18.623 0 12 5.377 0 12 0Zm0 .5C18.347.5 23.5 5.653 23.5 12S18.347 23.5 12 23.5.5 18.347.5 12 5.653.5 12 .5Z" />
					</svg>
				)}
				{'1' === avatarBorder && 'star' === avatarShape && (
					<svg
						viewBox="0 0 24 24"
						xmlns="http://www.w3.org/2000/svg"
						fillRule="evenodd"
						width="100%"
						height="100%"
						fill="currentColor"
					>
						<path d="m12 .587 3.668 7.568L24 9.306l-6.064 5.828 1.48 8.279L12 19.446l-7.417 3.967 1.481-8.279L0 9.306l8.332-1.151L12 .587Zm0 1.146 3.218 6.64.382.277 7.31 1.01-5.32 5.114-.146.448 1.298 7.264-6.506-3.481h-.472l-6.507 3.481 1.299-7.264-.146-.448L1.09 9.66 8.4 8.65l.382-.277L12 1.733Z" />
					</svg>
				)}
				{'1' === avatarBorder && 'rounded' === avatarShape && (
					<svg
						viewBox="0 0 24 24"
						xmlns="http://www.w3.org/2000/svg"
						width="100%"
						height="100%"
						fill="currentColor"
					>
						<path d="M24 5a5 5 0 0 0-5-5H5a5 5 0 0 0-5 5v14a5 5 0 0 0 5 5h14a5 5 0 0 0 5-5V5Zm-.5 0v14a4.5 4.5 0 0 1-4.5 4.5H5A4.5 4.5 0 0 1 .5 19V5A4.5 4.5 0 0 1 5 .5h14A4.5 4.5 0 0 1 23.5 5Z" />
					</svg>
				)}
				{'1' === avatarBorder && 'circle' === avatarShape && (
					<svg
						viewBox="0 0 24 24"
						xmlns="http://www.w3.org/2000/svg"
						fillRule="evenodd"
						width="100%"
						height="100%"
						fill="currentColor"
					>
						<path d="M12 0c6.623 0 12 5.377 12 12s-5.377 12-12 12S0 18.623 0 12 5.377 0 12 0Zm0 .5C18.347.5 23.5 5.653 23.5 12S18.347 23.5 12 23.5.5 18.347.5 12 5.653.5 12 .5Z" />
					</svg>
				)}
				{'1' === avatarBorder && 'triangle' === avatarShape && (
					<svg
						viewBox="0 0 24 24"
						xmlns="http://www.w3.org/2000/svg"
						fillRule="evenodd"
						width="100%"
						height="100%"
						fill="currentColor"
					>
						<path d="M24 22H0L12 2l12 20Zm-.883-.5H.883L12 2.972 23.117 21.5Z" />
					</svg>
				)}
			</StyledImgWrapper>
		</StyledAvatar>
	);
}

const shapesSolid = {
	square:
		'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M24 0h-24v24h24v-24z"/></svg>',
	triangle:
		'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M24 22h-24l12-20z"/></svg>',
	rounded:
		'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M24 5c0-2.761-2.238-5-5-5h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14z"/></svg>',
	circle:
		'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><circle cx="12" cy="12" r="12"/></svg>',
	star:
		'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z"/></svg>',
};

// @link https://css-tricks.com/almanac/properties/m/mask-image/
const StyledImgWrapper = styled.span`
	display: inline-block;
	position: relative;

	background-image: ${(props) => `url(${props.avatar})`};
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;

	mask-image: ${(props) =>
		props.avatarShape && props.avatarShape.length
			? `url(data:image/svg+xml,${encodeURIComponent(shapesSolid[props.avatarShape])})`
			: ''};
	mask-size: contain;
	mask-repeat: no-repeat;
	mask-position: center;
`;

const StyledAvatar = styled.p`
	svg {
		position: absolute;
		top: 0;
		left: 0;
	}
`;

const StyledImg = styled.img`
	max-height: 250px;
	max-width: 250px;
	visibility: hidden;
`;
